import { ClientStatus } from '../../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../../context/ClientStatusContext';
import { fetchPracovneKroky } from '../../../../../../client/pracovnyKrok/pracovnyKrokListClient';
import PracovnyKrokListRequest from '../../../../../../model/pracovnyKrok/PracovnyKrokListRequest';

interface ReturnType {
  pracovneKrokyRequest: PracovnyKrokListRequest;
  pracovneKrokyStatus: ClientStatus;
  reloadPracovneKroky
}

export default (type: string, year: number, index: number, accessToken: string): ReturnType => {
  const {
    data: pracovneKrokyRequest,
    status: pracovneKrokyStatus,
    refetch: reloadPracovneKroky,
  } = useClientFetch(
    fetchPracovneKroky,
    [type, year, index],
    [type, year, index, accessToken],
  );
  return {
    pracovneKrokyRequest,
    pracovneKrokyStatus,
    reloadPracovneKroky,
  };
};
